module.exports = __webpack_public_path__ + "static/img/image-box2.4c0f9006.jpg";